import { unauthorized, authorized } from "./api";
import { setTokenData } from "src/util/auth.util";
import type { PhoneT, VerifyT, NameT } from "src/types/authTypes";
export const sendPhoneApi = async (body: PhoneT) => {
  const send = await unauthorized.post(`/users/login`, body);
  return send.data;
};

export const sendOTPApi = async (body: VerifyT) => {
  const send = await unauthorized.post(`/users/login/verify`, body);
  setTokenData(send.data);
  return send.data;
};

export const refreshAccessKey = async () => {
  const send = await authorized.post(`/users/refresh-token`, undefined);
  console.log(send, "1414");
  return send.data;
};
